export enum EStore {
	APPS_INSTALLED = 'appsInstalledStore',
	APPS_BY_ID = 'appsByIdStore',
	APPS_NEW = 'appsNewStore',
	APPS_POPULAR = 'appsPopularStore',
	APPS_SALES = 'appsSalesStore',
	APPS_BY_GENRE = 'appsByGenreStore',
	APPS_BY_GENRE_COMPILATION = 'appsByGenreCompilationStore',
	APP = 'appStore',
	UI = 'uiStore',
	SHOWCASE = 'showcaseStore',
	CURRENT_USER = 'currentUserStore',
	MAIN_MENU_APPS = 'mainMenuAppsStore',
	COUNTERS = 'countersStore',
}
